<template>
    <div class="renewal">
       <div class="title">续租须知</div>
       <div class="box">
         <p>1、续租为预订原订单门店、车辆；</p>
         <p>2、续租取车时间为原订单还车时间；</p>
         <p>3、续租需早于原订单还车时间2小时，少于2小时则无法续租；</p>
         <p>4、最多可连续续租3次；</p>
         <p>5、单次续租时间最多不得超过30天；</p>
         <p>6、提交续租申请后，需在30分钟内支付完成，否则订单将自动取消，如要续租请重新发起续租。</p>
<!--            <p>续租的车辆和门店/送车点必须与原订单保持一致，原订单的还车时间就是续租的取车时间。</p>-->
<!--            <p>·距离原订单的还车时间≥2小时才能申请续租，距离原订单的还车时间＜2小时无法申请续租；</p>-->
<!--            <p>·单次续租时间需≤29天，申请续租能否成功视车辆的库存情况而定，如申请续租失败请按照系统提示操作或联系租车门店；</p>-->
<!--            <p>·续租订单需在30分钟内完成支付，支付成功后立即生效，超过30分钟未支付自动取消，需按照原订单的还车时间还车；</p>-->
<!--            <p>·每个订单最多可连续在线申请续租3次，超过3次仍需续租，请联系租车门店；</p>-->
<!--            <p>·详细续租事项请见《大方租车续租协议》。</p>-->
        </div>
    </div>
</template>
<script>
export default {
    name:"",
    data(){
        return{

        }
    }
}
</script>
<style lang="scss" scoped type="text/scss">
    .renewal{
        text-align: center;
        box-sizing: border-box;
        background:rgba(251,251,251,1);
        border-radius:10px;
        padding: 20px 30px;
        .title{
            font-size: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            color:#434343;
            line-height: 35px;
        }
        .title::before,.title::after{
            content: '';
            width:70px;
            height: 0;
            margin:0 5px;
            border-bottom:1px solid #bbbbbb;
        }
        .box{
            box-sizing:border-box;
            padding: 20px 30px;
            text-align: start;
            color:#999999;

        }
    }
</style>